import React from 'react';

/**
 * Store the browser name within a context so that it can
 * be accessed anywhere within the application tree.
 */
const BrowserContext = React.createContext();

export default BrowserContext;
